import {NgModule} from '@angular/core';
import {DynamicFieldsGroupComponent} from './components/dynamic-fields-group/dynamic-fields-group.component';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {LayoutModule} from '../../layout-components/layout.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormFieldModule,
        LayoutModule,
    ],
    exports: [
        DynamicFieldsGroupComponent,
    ],
    declarations: [
        DynamicFieldsGroupComponent,
    ],
    providers: [],
})
export class DynamicFieldsModule {

}
